<template>

    <div class="page__alerts block error">
        <div class="alert alert--warning">
            {{message}}
        </div>
    </div>

</template>

<script>

    export default {
        props: {
            message: {
                type: String,
                default: 'Возникла непредвиденная ошибка'
            },
        },
    }

</script>

<style scoped>
    .error {
        margin: 0 auto;
        max-width: 80%;
    }
</style>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/ErrorAlert.vue